import {
  Bell,
  ChartBar,
  Copy,
  Download,
  LayoutDashboard,
  Package,
  Plus,
  Receipt,
  ShieldCheck,
  ShoppingBag,
  Storefront,
  TrendingUp,
  Truck,
  UserCog,
  Users,
} from "@/components/icons";
import type { SidebarData } from "../types";

export const sidebarData: SidebarData = {
  navGroups: [
    {
      title: "ທົ່ວໄປ",
      items: [
        {
          title: "ແຜງຄວບຄຸມ",
          url: "/app/dashboard",
          icon: LayoutDashboard,
        },
      ],
    },
    {
      title: "ການຂາຍ",
      tourId: "sidebar-sales",
      items: [
        {
          title: "ສ້າງອໍເດີ້",
          url: "/app/orders/new",
          icon: Plus,
          requiredPermissions: ["orders:write"],
        },
        {
          title: "ອໍເດີ້",
          url: "/app/orders",
          icon: Receipt,
          requiredPermissions: ["orders:read"],
        },
        {
          title: "ງານສັ່ງເຮັດ",
          url: "/app/custom-jobs",
          icon: ShoppingBag,
          requiredPermissions: ["custom_jobs:read"],
        },
        {
          title: "ລາຍການລໍຖ້າສິນຄ້າ",
          url: "/app/restock-waitlist",
          icon: Bell,
          requiredPermissions: ["restock_waitlist:read"],
        },
        {
          title: "ອອກງານ",
          url: "/app/event-sales",
          icon: Storefront,
          requiredPermissions: ["event_sales:read"],
        },
        {
          title: "ລູກຄ້າ",
          url: "/app/customers",
          icon: Users,
          requiredPermissions: ["orders:read"],
        },
        {
          title: "ຈັດສົ່ງ",
          url: "/app/fulfillment",
          icon: Truck,
          requiredPermissions: ["orders:read"],
        },
        {
          title: "ຂໍ້ຄວາມແຊດ",
          url: "/app/chat-snippets",
          icon: Copy,
          requiredPermissions: ["orders:read"],
        },
      ],
    },
    {
      title: "ວິເຄາະ",
      items: [
        {
          title: "ຍອດຂາຍ",
          url: "/app/reports?tab=sales",
          icon: TrendingUp,
          requiredPermissions: ["orders:read"],
        },
        {
          title: "ກຳໄລ",
          url: "/app/reports?tab=profit",
          icon: ChartBar,
          requiredPermissions: ["orders:read"],
        },
        {
          title: "ສະຕັອກ",
          url: "/app/reports?tab=stock",
          icon: Package,
          requiredPermissions: ["orders:read"],
        },
        {
          title: "ຂົນສົ່ງ",
          url: "/app/reports?tab=shipping",
          icon: Truck,
          requiredPermissions: ["orders:read"],
        },
        {
          title: "ລູກຄ້າ",
          url: "/app/reports?tab=customers",
          icon: Users,
          requiredPermissions: ["orders:read"],
        },
        {
          title: "ງານສັ່ງເຮັດ",
          url: "/app/reports?tab=custom_jobs",
          icon: ShoppingBag,
          requiredPermissions: ["custom_jobs:read"],
        },
        {
          title: "ລາຍຈ່າຍ",
          url: "/app/expenses",
          icon: Receipt,
          requiredPermissions: ["expenses:read"],
        },
      ],
    },
    {
      title: "ສິນຄ້າ",
      items: [
        {
          title: "ສິນຄ້າ & ສະຕັອກ",
          url: "/app/products",
          icon: Package,
          requiredPermissions: ["products:read"],
        },
        {
          title: "ຮັບເຂົ້າສະຕັອກ",
          url: "/app/inventory",
          icon: Download,
          requiredPermissions: ["inventory:read"],
        },
        {
          title: "ວາງແຜນສັ່ງຂອງ",
          url: "/app/inventory/planning",
          icon: Package,
          requiredPermissions: ["inventory:read"],
        },
        {
          title: "ປະກອບ / ແຍກຊຸດ",
          url: "/app/inventory/assembly",
          icon: Package,
          requiredPermissions: ["inventory:read"],
        },
        {
          title: "ສັ່ງນຳເຂົ້າ",
          url: "/app/import-orders",
          icon: Package,
          requiredPermissions: ["import_orders:read"],
        },
      ],
    },
    {
      title: "ການຄວບຄຸມການເຂົ້າເຖິງ",
      items: [
        {
          title: "ບົດບາດ",
          url: "/app/roles",
          icon: UserCog,
          requiredPermissions: ["users:read"],
        },
        {
          title: "ຜູ້ໃຊ້",
          url: "/app/users",
          icon: Users,
          requiredPermissions: ["users:read"],
        },
        {
          title: "ບັນທຶກການກວດກາ",
          url: "/app/audit",
          icon: ShieldCheck,
          requiredPermissions: ["audit:read"],
        },
      ],
    },
  ],
};
